import { render, staticRenderFns } from "./IdentificationChecksAmlScreening.vue?vue&type=template&id=4cb71182&scoped=true"
import script from "./IdentificationChecksAmlScreening.vue?vue&type=script&lang=js"
export * from "./IdentificationChecksAmlScreening.vue?vue&type=script&lang=js"
import style0 from "./IdentificationChecksAmlScreening.vue?vue&type=style&index=0&id=4cb71182&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb71182",
  null
  
)

export default component.exports